import vm from "../main";
import axios from "./PointrCloudAxios";

export default class TaxonomyService {
  static async getTaxonomy(clientIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.get(`/content/draft/clients/${clientIdentifier}/taxonomies`);
    } catch (error) {
      console.error(error);
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    let dictByTypeCode = {};
    response?.data?.forEach((type) => {
      dictByTypeCode[type.typeCode] = type;
    });
    return dictByTypeCode;
  }
}
